import { BFormCheckbox, BFormTextarea } from 'bootstrap-vue'
import { BFormInput } from 'bootstrap-vue'
import Dropdown from '../../components/dropdown/Dropdown.vue'
import AutoComplete from '../../components/Autocomplete.vue'
import Tooltip from '../../components/tooltip/Tooltip.vue'

export class DefaultInput {
    constructor(label, placeholder) {
        this.label = label
        this.placeholder = placeholder || ''
    }

    getComponent() {
        return BFormInput
    }

    getInputType(type) {
        return type === 'password' ? type : 'text'
    }

    getModel(resource, i) {
        return resource.attributes[i]
    }

    // Not needed for regular input
    setValue() {}
}

export class DefaultTextarea {
    constructor(label, placeholder, rows) {
        this.label = label
        this.placeholder = placeholder || ''
        this.rows = rows || 2
    }

    getComponent() {
        return BFormTextarea
    }

    getInputType() {
        return 'text'
    }

    getModel(resource, i) {
        return resource.attributes[i]
    }

    setValue() {}
}

export class DefaultCheckboxOld {
    constructor(label) {
        this.label = label
    }

    getComponent() {
        return BFormCheckbox
    }

    getInputType() {
        return 'checkbox'
    }

    getModel(resource, i) {
        return resource.attributes[i]
    }

    // Not needed for regular input
    setValue() {}
}

export class DefaultToolTip {
    constructor(label, title, attribute, placeholder) {
        this.label = label
        this.title = title
        this.attribute = attribute
        this.placeholder = placeholder
    }

    getComponent() {
        return Tooltip
    }
}

export class DefaultCheckbox extends DefaultInput {
    constructor(label, attribute) {
        super(label, attribute)
        this.label = label
        this.value = attribute
        this.type = 'checkbox'
    }

    getComponent() {
        return BFormCheckbox
    }

    getInputType() {
        return 'checkbox'
    }

    // Not needed for regular input
    setValue(a) {
        // console.log(a)
    }
}

export class DefaultFormSelect extends DefaultInput {
    constructor(label, options, attribute) {
        super(label)
        this.options = options
        this.attribute = attribute
    }

    getComponent() {
        return Dropdown
    }
}

export class DefaultFormAutocomplete extends DefaultInput {
    constructor(label, resourceClass, attribute, filters) {
        super(label)
        this.attribute = attribute
        this.resourceClass = resourceClass
        this.filterOptions = filters
    }

    getComponent() {
        return AutoComplete
    }

    setValue(value, resourceInstance, i) {
        if (value && resourceInstance && i) {
            resourceInstance.set(i, value.id || value.attributes.id)
        }
    }
}
